const initials = "userProfile/";
export const UPDATE_USER_PROFILE = `${initials}UPDATE_USER_PROFILE`;

